import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ConfirmDirective} from "../../../../../directives/confirm/confirm.directive";
import {IsGrantedDirective} from "../../../../../directives/is-granted/is-granted.directive";
import {PartnerGoogleAdsService} from '../../../../../services/partner/partner-google-ads.service';
import {PartnerAdvertisingPlatform} from '../../../../../models/partner/partner-advertising-platform';

@Component({
  imports: [
    ConfirmDirective,
    IsGrantedDirective
  ],
  selector: 'app-google-ads-config-form',
  styleUrl: './google-ads-config-form.component.scss',
  templateUrl: './google-ads-config-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GoogleAdsConfigFormComponent implements OnChanges {
  @Input() partnerAdvertisingPlatform: PartnerAdvertisingPlatform | null = null;

  accountInfos: any | null = null;
  conversionActions: any[] | null = [];
  partnerId: number | null = null;

  constructor(
    private partnerGoogleAdsService: PartnerGoogleAdsService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['partnerAdvertisingPlatform']) {
      this.partnerId = this.partnerAdvertisingPlatform?.partnerId ?? null;
      this.refreshAccountInfos();
    }
  }

  refreshAccountInfos(): void {
    if (this.partnerId) {
      this.accountInfos = null;
      this.partnerGoogleAdsService.getAccountInfos(this.partnerId).subscribe((accountInfos) => {
        this.accountInfos = accountInfos;
        this.refreshActionStatus();
      });
    }
  }

  refreshActionStatus(): void {
    if (this.partnerId) {
      this.conversionActions = null;
      this.partnerGoogleAdsService.getConversionActionsStatus(this.partnerId).subscribe((actions) => {
        this.conversionActions = actions;
      });
    }
  }

  createActions(): void {
    if (this.partnerId) {
      this.conversionActions = null;
      this.partnerGoogleAdsService.createConversionActionsStatus(this.partnerId).subscribe(() => {
        this.refreshActionStatus();
      });
    }
  }

  getGoogleAdsTimezoneOffset(): string {
    if (this.accountInfos) {
      let offset = this.accountInfos.timezoneOffset;
      if (offset > 0) {
        return 'UTC+' + offset;
      }

      if (offset < 0) {
        return 'UTC' + offset;
      }

      return 'UTC';
    }

    return '';
  }
}
